import React from 'react';
import SystemFlag from '@/components/SystemFlag';
import matchAttachmentType, { getAttachmentType } from '../helper';
import { ATTACHMENT_TYPE } from '../constants';

const AttachmentTypeFlag = ({ attachment }) => (
  <SystemFlag
    className="aridhia-attachment-type-flag"
    flush
    messageId={`dataset.attachments.type.${getAttachmentType(attachment).name}`}
    solid={matchAttachmentType(attachment, ATTACHMENT_TYPE.attachment)}
  />
);

export default AttachmentTypeFlag;
